import { AccessDeniedError, type AuthorizationManager } from './types.ts';
import { AsyncStorageSecurityContextHolder, type SecurityContext } from './security-context.ts';
import type { AsyncLocalStorage } from 'node:async_hooks';
import type { ServerWebExchange } from '../../../types/web/server';

import getLogger from '../../logger.ts';
import type { WebFilterChain } from '../../web/server/types.ts';

const logger = getLogger('security.auth');

export default function authorizationFilter(opts: {
    storage: AsyncLocalStorage<{ securityContext?: Promise<SecurityContext> }>,
    manager: AuthorizationManager<ServerWebExchange>
}) {

    const { manager, storage } = opts;

    return {
        filter: async (exchange: ServerWebExchange, chain: WebFilterChain) => {
            const promise = AsyncStorageSecurityContextHolder.getContext(storage)
                .then(c => c?.authentication);
            try {
                await manager.verify(promise, exchange);
                if (logger.enabledFor('debug')) {
                    logger.debug('authorization successful')
                }
            }
            catch (error) {
                if (error instanceof AccessDeniedError) {
                    if (logger.enabledFor('debug')) {
                        logger.debug(`authorization failed: ${error.message}`);
                    }
                }
                throw error;
            }
            await chain.filter(exchange);
        }
    };
}
